import { render, staticRenderFns } from "./element-handler.vue?vue&type=template&id=8c1bc0ba&"
import script from "./element-handler.vue?vue&type=script&lang=js&"
export * from "./element-handler.vue?vue&type=script&lang=js&"
import style0 from "./element-handler.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports